import HyperlinkMixin from '@/components/Base/HyperlinkMixin';
import {
    levelBasicUser
} from '@/store/user';

export default {

    mixins: [ HyperlinkMixin ],

    data: function () {
        return {
            heros: [],
            heroOptions: {
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 1,
                arrows: false,
                variableWidth: false
            },
            suggestions: null,
            slickOptions1: {
                slidesToShow: 3,
                slidesToScroll: 2,
                rows: 1,
                arrows: true,
                variableWidth: false,
                adaptiveHeight: false,
                speed: 1000,
                responsive: [
                    {
                        breakpoint: 801,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            speed: 500
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            },
            slickOptions2: {
                slidesToShow: 2,
                slidesToScroll: 2,
                rows: 1,
                arrows: true,
                variableWidth: false,
                adaptiveHeight: false,
                speed: 1000,
                responsive: [
                    {
                        breakpoint: 650,
                        settings: "unslick"
                    }
                ]
            },
            slickOptions2b: {
                slidesToShow: 2,
                slidesToScroll: 2,
                rows: 1,
                arrows: true,
                variableWidth: false,
                adaptiveHeight: false,
                speed: 1000,
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            variableWidth: false,
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            variableWidth: false,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            },
            slickOptions3: {
                slidesToShow: 4,
                slidesToScroll: 4,
                rows: 1,
                arrows: true,
                variableWidth: false,
                adaptiveHeight: false,
                speed: 1000,
                responsive: [
                    {
                        breakpoint: 650,
                        settings: "unslick"
                    }
                ]
            },
            slickOptions4: {
                slidesToShow: 3,
                slidesToScroll: 2,
                rows: 1,
                arrows: true,
                variableWidth: false,
                adaptiveHeight: false,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 800,
                        settings: {
                            variableWidth: false,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            },
            slickOptions5: {
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 1,
                arrows: true,
                variableWidth: false,
                adaptiveHeight: true,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 650,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            },
            popoverAnimation1: {
                show: {
                    type: 'pop',
                    from: {
                        scale: 0
                    },
                    to: {
                        scale: 1
                    }
                },
                hide: {
                    type: 'fade',
                    from: 1,
                    to: 0
                }
            },
            levelBasicUser,
            isDeactivated: false,
            ready: false,
            error: null
        };
    },

    activated: function () {
        this.isDeactivated = false;
    },

    deactivated: function () {
        this.isDeactivated = true;
    },

    methods: {
        /**
         * UseProfile for Index Views.
         * Use "EditAll" in edit mode.
         * NOTE: the view needs to have UseProfileMixin.
         */
        getIndexQueryUseProfile: function () {
            return this.doEdit ? 'EditAll' : this.getUseProfile_ViewCache();
        },

        /**
         * Data for vue-autosuggest drop-down.
         * The search-input-autocomplete will display "progress" cursor
         * until given suggestions is truthy, such as empty array.
         */
        getSuggestions: function () {
            return [];
        },

        getSampleArtworks: async function (text = '', queryParams = {}, amount = 10, pageSize = amount, pageIndex = 0) {
            const params = _.extend({
                UseProfile: 'ViewPublicOnly',
                PageSize: pageSize,
                PageIndex: pageIndex,
                Text: text,
                EnableFacetedSearch: false,
                HasImage: true,
                Template: {
                    IndexProperties: true,
                    ObjectProperties: false,
                    Dimensions: false,
                    Makers: true,
                    MakersProperties: 'MakersActorSimple',
                    ImageInfoExtended: true
                }
            }, queryParams);

            return new Promise((resolve, reject) => {
                this.$SVC.queryArtworks(params)
                    .then((response) => {
                        if (response.data && response.data.Results) {
                            const items = response.data.Results;
                            resolve(_.take(_.shuffle(items), amount));
                        }
                        else {
                            resolve([]);
                        }
                    })
                    .catch(reject);
            });
        },

        getLocalizedSearchRoute: function (view, query = {}) {
            return this.getLocalizedRoute(view, this.$i18n.locale, query);
        },

        paginationCallback: function () {},

        stackCallback: function () {}
    }
};
